module.exports = __webpack_public_path__ + "img/deviceList_U.a1edfc1a.png";